import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { NzConfigService } from 'ng-zorro-antd/core/config';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private darkMode = new BehaviorSubject<boolean>(false);
  isDarkMode$ = this.darkMode.asObservable();

  constructor(private nzConfigService: NzConfigService) {
    this.initializeTheme();
  }

  private initializeTheme() {
    const savedTheme = localStorage.getItem('theme');
    const isDark = savedTheme ? savedTheme === 'dark' : false;
    this.setTheme(isDark);
  }

  setTheme(isDark: boolean) {
    this.darkMode.next(isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');

    // Update body classes
    const body = document.body;
    body.classList.remove(isDark ? 'light-theme' : 'dark-theme');
    body.classList.add(isDark ? 'dark-theme' : 'light-theme');
  }

  toggleTheme() {
    this.setTheme(!this.darkMode.value);
  }
}
